import React, { useContext, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import './RewardsModal.module.css'
import Accordion from 'react-bootstrap/Accordion';
import { dataContext } from '../../../App';
import activityLogSubmission from '../../../helper/activitylog';
import analyticEvent from '../../../helper/gaEvent';
import { pushCleverTapEvent } from '../../../helper/clevertapFunction';
import styles from './RewardsModal.module.css'
import './RewardsModal.css'

const RewardsModal = ({ showRewardsModal, setShowRewardsModal }) => {
  const { playerData } = useContext(dataContext);

  function hideModalOperation() {
    setShowRewardsModal(false)
  }

  useEffect(() => {
    let msisdn = null;
    if (playerData?.id) {
      msisdn = playerData?.msisdn;
    }
    activityLogSubmission("rewards", msisdn);
    analyticEvent('rewards', 'rewards-view')
    pushCleverTapEvent('CheckIn-Prize');
  }, [])

  return (
    <>
      <div className={styles.rewardsModal}>
        <div className={styles.rewardsModalHeader}>
          <img src={require('./rewards.png')} className={styles.rewardsModalIcon} alt="medal" />
          <span className={styles.rewardsModalTitle}>প্রাইজের তালিকা</span>
        </div>
        <div style={{ textAlign: 'justify' }}>

          <b>বিজয়ীদের পুরস্কার :</b> Wordly কর্তৃপক্ষ বিজয়ীদের দৈনিক, টুর্নামেন্ট ভিত্তিক পুরস্কার প্রদান করে থাকে ।
        </div>
        <Accordion className={styles.accordion}>
          <Accordion.Item eventKey="4" className={styles.accordionItem}>
            <Accordion.Header className={styles.accordionButton}>সাপ্তাহিক ক্যাম্পেইন এর সময়সীমা</Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              * প্রতি সোমবার থেকে রবিবার পর্যন্ত।<br />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3" className={styles.accordionItem}>
            <Accordion.Header className={styles.accordionButton}>টুর্নামেন্ট এর সময়সীমা</Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              * ১লা জুলাই ২০২৬ থেকে ৩১শে ডিসেম্বর ২০২৬<br />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="0" className={styles.accordionItem}>
            <Accordion.Header className={styles.accordionButton}>Memory Match পুরস্কার</Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              মেমোরি ম্যাচ গেমে প্রতিদিনের শীর্ষ ৩০ জন বিজয়ী পাবেন ১০ টাকা করে মোবাইল রিচার্জ পুরস্কার।
              <br />
              ***এক সপ্তাহের ডেইলি প্রাইজ একসাথে সপ্তাহের সোমবার দেয়া হয়ে থাকে।<br />
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1" className={styles.accordionItem}>
            <Accordion.Header className={styles.accordionButton}>Wordly পুরস্কার</Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              <ul>
                <li>দৈনিক পুরস্কার: প্রতিদিনের অংশগ্রহণকারীদের মধ্যে সেরা ২০ জন সঠিক উত্তর প্রদানকারী কে ১০ টাকা মোবাইল রিচার্জ করা হবে |</li>
              </ul>
              ***এক সপ্তাহের ডেইলি প্রাইজ একসাথে সপ্তাহের সোমবার দেয়া হয়ে থাকে।<br />
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2" className={styles.accordionItem}>
            <Accordion.Header className={styles.accordionButton}>Spelling Bee পুরস্কার</Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              <ul>
                <li>দৈনিক পুরস্কার: প্রতিদিনের অংশগ্রহণকারীদের মধ্যে সেরা ২০ জন সঠিক উত্তর প্রদানকারী কে ১০ টাকা মোবাইল রিচার্জ করা হবে |</li>
              </ul>
              ***এক সপ্তাহের ডেইলি প্রাইজ একসাথে সপ্তাহের সোমবার  দেয়া হয়ে থাকে।<br />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <div style={{ textAlign: 'justify' }}>
          ** আয়োজক সত্তা তার বিবেচনার ভিত্তিতে পুরস্কার পরিবর্তন বা প্রতিস্থাপন করার অধিকার সংরক্ষণ করে।
        </div>
      </div>
    </>
  )
}

export default RewardsModal